import { HTMLInputAutoCompleteAttribute } from "react";
import { FieldValues, Path } from "react-hook-form";

import {
    InputMask,
    MaskedInput
} from "@/components/Form/Base/maskedInput.component";
import { BaseField } from "@/components/Form/RHF/FormFields/BaseField/BaseField.component";

import { useAutofill } from "../../Utils/useAutofill";
import { FormValuesExploded } from "../formField.types";

type MaskedFieldProps<T extends FieldValues> = FormValuesExploded<T> & {
    inputMask: InputMask;
    autoComplete?: HTMLInputAutoCompleteAttribute;
};

export const MaskedField = <T extends FieldValues>({
    inputMask,
    name,
    label,
    microCopy,
    required,
    autoComplete
}: MaskedFieldProps<T>) => {
    const { handleOnAutofill } = useAutofill<T>(name);

    return (
        <BaseField<T, Path<T>>
            label={label}
            name={name}
            microCopy={microCopy}
            required={required}
        >
            {({ field, fieldState }) => {
                return (
                    <MaskedInput<T>
                        isInvalid={fieldState.isInvalid}
                        isValid={fieldState.isValid}
                        field={field}
                        inputMask={inputMask}
                        autoComplete={autoComplete}
                        onAutofill={handleOnAutofill}
                    />
                );
            }}
        </BaseField>
    );
};
